export enum ORDER_SIDE {
	ALL = "",
	BUY = "BUY",
	SELL = "SELL",
}
